module.exports = __webpack_public_path__ + "img/configurator-promo.e529dfb1.png";